import { Component, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder } from "@angular/forms";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { ReviewService } from "src/app/review/review.service";
import { AccountService, HttpCommonService } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "ngx-customer-review",
  templateUrl: "./customer-review.component.html",
  styleUrls: ["./customer-review.component.scss"],
  providers: [ReviewService],
})
export class CustomerReviewComponent implements OnInit, OnDestroy {
  ngUnsubscribe = new Subject<void>();
  formGroup: UntypedFormGroup;
  activeTabTitle: string;
  unSortableFilterable: string[] = [];
  SecurityReviewInfoColumns: form_control[] = [];
  BranchIds: number[] = [];
  SaleMethodIds: number[] = [];
  ZoneIds: number[] = [];
  InvoiceCommandIds: number[] = [];
  InvoiceStatusIds: number[] = [];
  InvoiceChangesIds: number[] = [];
  InvoicePayableChangeIds: number[] = [];
  CustomerCategoryIds: number[] = [];
  GetCustomerCategorySummaryListColumns: form_control[] = [];
  GetCustomerSummaryListColumns: form_control[];
  GetCustomercategoryColumns: form_control[];
  GetItemSummaryColumns: form_control[] = [];
  GetInvoiceSummaryListColumns: form_control[] = [];
  GetInvoiceItemSummaryListColumns: form_control[] = [];
  GetInvoiceReceiptPaymentSummaryListColumns: form_control[] = [];
  GetCustomerReceiptPaymentSummaryListColumns: form_control[] = [];
  selected: string = "";
  accountstatus = undefined;

  public isMultiBranch =
    (this.accountService.authService.currentInformation().BranchingAdvancedEnabled ||
      this.accountService.authService.currentInformation().BranchingLightEnabled ||
      this.accountService.authService.currentInformation().RestaurantCallCenter) &&
    this.accountService.authService.currentBranch?.AccessToAllBranches;

  constructor(
    private service: ReviewService,
    private fb: UntypedFormBuilder,
    private accountService: AccountService,
    private translate: TranslateService,
    private httpCommonService: HttpCommonService
  ) {}
  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }

    this.formGroup = undefined;
    this.activeTabTitle = undefined;
    this.SecurityReviewInfoColumns = undefined;
    this.BranchIds = undefined;
    this.SaleMethodIds = undefined;
    this.ZoneIds = undefined;
    this.InvoiceCommandIds = undefined;
    this.InvoiceStatusIds = undefined;
    this.InvoiceChangesIds = undefined;
    this.InvoicePayableChangeIds = undefined;
    this.CustomerCategoryIds = undefined;
    this.GetCustomerCategorySummaryListColumns = undefined;
    this.GetCustomerSummaryListColumns = undefined;
    this.GetCustomercategoryColumns = undefined;
    this.GetInvoiceSummaryListColumns = undefined;
    this.GetInvoiceItemSummaryListColumns = undefined;
    this.GetItemSummaryColumns = undefined;
    this.GetInvoiceReceiptPaymentSummaryListColumns = undefined;
    this.GetCustomerReceiptPaymentSummaryListColumns = undefined;
  }

  ngOnInit(): void {
    this.unSortableFilterable = [...this.unSortableFilterable,"Mobile", "Title"]
    this.service.startDate = new Date();
    this.service.endDate = new Date();
    this.service.ReportKey = "CustomerReview";
    this.service.startDate$.next(this.service.startDate);
    this.service.endDate$.next(this.service.endDate);
    this.formGroup = this.fb.group({
      SaleMethodIds: this.SaleMethodIds,
      BranchIds: this.BranchIds,
      ZoneIds: this.ZoneIds,
      InvoiceCommandIds: this.InvoiceCommandIds,
      InvoiceStatusIds: this.InvoiceStatusIds,
      InvoiceChangesIds: this.InvoiceChangesIds,
      InvoicePayableChangeIds: this.InvoicePayableChangeIds,
      IncludeCancelled: true,
      CustomerCategoryIds: this.CustomerCategoryIds,
      accountstatus: this.accountstatus,
    });
  }
  selectTab($event) {
    this.setColumns($event.tabTitle);
    this.activeTabTitle = $event.tabTitle;
  }
  chartData: any[];
  isActveTab(title: string) {
    return this.activeTabTitle === title;
  }
  setColumns(activeTabTitle: string) {
    switch (activeTabTitle) {
      case this.translate.instant("ClientApp.FrontOffice.Review.CustomerReview.CustomerCategory"):
        if (!this.GetCustomercategoryColumns || this.GetCustomercategoryColumns?.length <= 0) {
          this.httpCommonService
            .get("CustomerReview/GetCustomercategoryColumns")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetCustomercategoryColumns = data as form_control[];
                  this.GetCustomercategoryColumns = this.GetCustomercategoryColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        break;
      case this.translate.instant("ClientApp.FrontOffice.Review.CustomerReview.CustomerSummaryList"):
        if (!this.GetCustomerSummaryListColumns || this.GetCustomerSummaryListColumns?.length <= 0) {
          this.httpCommonService
            .get("CustomerReview/GetCustomerSummaryListColumns")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetCustomerSummaryListColumns = data as form_control[];
                  this.GetCustomerSummaryListColumns = this.GetCustomerSummaryListColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        break;
      case this.translate.instant("ClientApp.FrontOffice.Review.CustomerReview.Factor"):
        if (!this.GetInvoiceSummaryListColumns || this.GetInvoiceSummaryListColumns?.length <= 0) {
          this.httpCommonService
            .get("CustomerReview/GetInvoiceModelInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetInvoiceSummaryListColumns = data as form_control[];
                  this.GetInvoiceSummaryListColumns = this.GetInvoiceSummaryListColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        break;
      case this.translate.instant("ClientApp.FrontOffice.Review.CustomerReview.FactorDetail"):
        if (!this.GetInvoiceItemSummaryListColumns || this.GetInvoiceItemSummaryListColumns?.length <= 0) {
          this.httpCommonService
            .get("CustomerReview/GetInvoiceItemModelInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetInvoiceItemSummaryListColumns = data as form_control[];
                  this.GetInvoiceItemSummaryListColumns = this.GetInvoiceItemSummaryListColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        break;
      case this.translate.instant("ClientApp.FrontOffice.Review.CustomerReview.PaymentSummaryList"):
        if (!this.GetInvoiceReceiptPaymentSummaryListColumns || this.GetInvoiceReceiptPaymentSummaryListColumns?.length <= 0) {
          this.httpCommonService
            .get("CustomerReview/GetInvoiceReceiptPaymentInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetInvoiceReceiptPaymentSummaryListColumns = data as form_control[];
                  this.GetInvoiceReceiptPaymentSummaryListColumns = this.GetInvoiceReceiptPaymentSummaryListColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        break;
      case this.translate.instant("ClientApp.FrontOffice.Review.CustomerReview.ReceiptPaymentList"):
        if (!this.GetCustomerReceiptPaymentSummaryListColumns || this.GetCustomerReceiptPaymentSummaryListColumns?.length <= 0) {
          this.httpCommonService
            .get("CustomerReview/GetCustomerReceiptPaymentInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetCustomerReceiptPaymentSummaryListColumns = data as form_control[];
                  this.GetCustomerReceiptPaymentSummaryListColumns = this.GetCustomerReceiptPaymentSummaryListColumns.sort(
                    (a, b) => a.order - b.order
                  );
                }
              },
              (error) => console.log(error)
            );
        }
        break;
      case this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.Item"):
        if (this.GetItemSummaryColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetItemSaleSummaryModelInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetItemSummaryColumns = data as form_control[];
                  this.GetItemSummaryColumns = this.GetItemSummaryColumns.filter(
                    (x) =>
                      x.name !== "Total" &&
                      x.name !== "TotalRounding" &&
                      x.name !== "TotalTip" &&
                      x.name !== "TotalShippingCost" &&
                      x.name !== "PayableTotal" &&
                      x.name !== "TotalDebit" &&
                      x.name !== "TotalCredit" &&
                      x.name !== "PayableTotal" &&
                      x.name !== "Total" &&
                      x.name !== "BranchTitle"
                  ).sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        break;
      default:
        break;
    }
  }

  setSelectedFilter(filter: string) {
    if (this.selected === filter) this.selected = "";
    else this.selected = filter;
  }
}
